export const VALID_USER = ['User Enovate', 'Admin'];